import { html } from 'lit';
const HelpCenter =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.004 3.8a8.2 8.2 0 0 0-7.348 11.845c.265.533.257 1.202.196 1.755-.065.59-.215 1.224-.377 1.79-.103.363-.214.708-.318 1.01h7.847a8.2 8.2 0 0 0 0-16.4M2.266 20.692l.003-.007.012-.028.045-.114a20 20 0 0 0 .61-1.791c.15-.526.274-1.064.326-1.528.055-.503.008-.772-.039-.867A9.76 9.76 0 0 1 2.203 12c0-5.412 4.388-9.8 9.8-9.8s9.8 4.388 9.8 9.8-4.387 9.8-9.8 9.8H3.006a.8.8 0 0 1-.739-1.108m9.7-11.642a1.2 1.2 0 0 0-1.161.9.8.8 0 0 1-1.55-.4 2.8 2.8 0 0 1 5.512.7c0 .856-.414 1.425-.87 1.865-.186.18-.4.357-.598.521l-.086.072a10 10 0 0 0-.68.608.8.8 0 1 1-1.132-1.132c.278-.277.551-.509.789-.706l.091-.076c.204-.169.365-.303.505-.438.295-.284.38-.465.38-.714a1.2 1.2 0 0 0-1.2-1.2m.011 7.5h-.01a.8.8 0 1 1 0-1.6h.01a.8.8 0 0 1 0 1.6" clip-rule="evenodd"/>
  </svg>
`;
export default HelpCenter;
